import BlockAdmins from '@/components/blocks/Admin/Admins/BlockAdmins';
import BlockDeletedAdmins from '@/components/blocks/Admin/Admins/BlockDeletedAdmins';
import BlockEditAdmin from '@/components/blocks/Admin/Admins/BlockEditAdmin';
import SuperAdminGuard from '@/services/RouteGuards/SuperAdmin';

export default [
	{
		path: 'users/admins',
		name: 'Admins',
		component: BlockAdmins,
		beforeEnter: SuperAdminGuard,
		meta: {
			title: `Admins - ${process.env.VUE_APP_NAME}`
		}
	},
	{
		path: 'users/admins/deleted',
		name: 'DeletedAdmins',
		component: BlockDeletedAdmins,
		meta: {
			title: `Deleted Admins - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'users/admin/edit/:id',
		name: 'EditAdmin',
		component: BlockEditAdmin,
		props: {
			edit: true,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `Edit Admin - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	},
	{
		path: 'users/admin/new',
		name: 'NewAdmin',
		component: BlockEditAdmin,
		props: {
			edit: false,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `New Admin - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperAdminGuard
	}
];
